/** Best-effort extract user-facing message from axios/API errors and generic Error shapes. */
export const getApiMessage = (err: unknown): string | null => {
    const e = err as {
        response?: { data?: { message?: unknown } };
        message?: unknown;
        error?: { message?: unknown };
        data?: { message?: unknown };
    };
    const message =
        e?.response?.data?.message ?? e?.message ?? e?.error?.message ?? e?.data?.message ?? null;
    return typeof message === 'string' ? message : null;
};
